<mat-card class="example-card">
        <mat-card-header *ngIf="showEnteteFenetre" class="titreFrm">
            <mat-card-title>Matière(s)</mat-card-title>
        </mat-card-header>
        <mat-card-content [ngClass]="showEnteteFenetre ? 'border' : ''">
            <div *ngIf="exist;else attente"></div>
            <ng-template #attente>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </ng-template>
            <mat-card *ngIf="showEnteteFenetre" class="example-card carClass">
                <mat-card-content>
                    <h5>
                        <span style="margin-right: 50px;" ><b>Cursus :</b> <span style="color: rgb(90, 86, 86);">{{cursus.Cursus_Titre}}</span></span>  <b>Durée:</b> <span style="color: rgb(90, 86, 86);">{{cursus.Cursus_Duree}} Heure(s)</span>
                    </h5>
                      
                    
                </mat-card-content>
            </mat-card>
            <mat-card class="example-card carClass">
                <mat-card-content>
                    <app-avt-listes [multipleSelect]="true"  #listeMatiereComponen [showFilter]="false" [heightTable]="'400'"
                        [dataSourceBrut]="[]" [displayedColumnsBrut]="columns" [listBtn]="listBtn"
                        (btnTable)="clickBtnHeat($event)"></app-avt-listes>
                </mat-card-content>
            </mat-card>
        </mat-card-content>
    </mat-card>